"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CronTask = void 0;
var CronTask;
(function (CronTask) {
    CronTask["AssignationsCheck"] = "AssignationsCheck";
    CronTask["AutocompleteTrackings"] = "AutocompleteTrackings";
    CronTask["AutoPostAssignationOffers"] = "AutoPostAssignationOffers";
    CronTask["AutoPublishAssignationOffers"] = "AutoPublishAssignationOffers";
    CronTask["CalculateDayTripsPopularity"] = "CalculateDayTripsPopularity";
    CronTask["CalculateLocationPopularity"] = "CalculateLocationPopularity";
    CronTask["CalculateRoutesPopularity"] = "CalculateRoutesPopularity";
    CronTask["CalculateCountryPopularity"] = "CalculateCountryPopularity";
    CronTask["CancelExpiredReservedOrders"] = "CancelExpiredReservedOrders";
    CronTask["CancelIncompleteApplePayPayments"] = "CancelIncompleteApplePayPayments";
    CronTask["CheckAndDeleteExpiredExports"] = "CheckAndDeleteExpiredExports";
    CronTask["CheckApprovedUsersFromMangopay"] = "CheckApprovedUsersFromMangopay";
    CronTask["CheckNotConfirmedOrdersWithAcceptedAssignation"] = "CheckNotConfirmedOrdersWithAcceptedAssignation";
    CronTask["ComputeAdwordsCampaignFeed"] = "ComputeAdwordsCampaignFeed";
    CronTask["ComputeMetaCampaignFeed"] = "ComputeMetaCampaignFeed";
    CronTask["ComputeRemarketingFeed"] = "ComputeRemarketingFeed";
    CronTask["CreateAutoChargebacks"] = "CreateAutoChargebacks";
    CronTask["CreateDefaultEarlyOfferCredits"] = "CreateDefaultEarlyOfferCredits";
    CronTask["CreateTravelAgentHyperWalletAccounts"] = "CreateTravelAgentHyperWalletAccounts";
    CronTask["DriverAvailabilityReminder"] = "DriverAvailabilityReminder";
    CronTask["EnsureMailgunConfiguration"] = "EnsureMailgunConfiguration";
    CronTask["ExecutePreauthorizedOrderPayments"] = "ExecutePreauthorizedOrderPayments";
    CronTask["FailStalePendingPayments"] = "FailStalePendingPayments";
    CronTask["FireTripLifecycleEvents"] = "FireTripLifecycleEvents";
    CronTask["GenerateHostAgencyCommissionSettlements"] = "GenerateHostAgencyCommissionSettlements";
    CronTask["GenerateInvoices"] = "GenerateInvoices";
    CronTask["GenerateSitemaps"] = "GenerateSitemaps";
    CronTask["GenerateTripOfferPreviews"] = "GenerateTripOfferPreviews";
    CronTask["GenerateIntrailReport"] = "GenerateIntrailReport";
    CronTask["GrantDriversTripOfferAccess"] = "GrantDriversTripOfferAccess";
    CronTask["HandleCancellationsAndPenaltiesDaily"] = "HandleCancellationsAndPenaltiesDaily";
    CronTask["InactiveUsersCheck"] = "InactiveUsersCheck";
    CronTask["Journal"] = "Journal";
    CronTask["MarkSettlementsAsPaid"] = "MarkSettlementsAsPaid";
    CronTask["NotFullyPaidOrdersReminder"] = "NotFullyPaidOrdersReminder";
    CronTask["NotifyCustomersFailedEmails"] = "NotifyCustomersFailedEmails";
    CronTask["NotifyForUnpaidPreauthorizedPayments"] = "NotifyForUnpaidPreauthorizedPayments";
    CronTask["OrdersAcceptationCheck"] = "OrdersAcceptationCheck";
    CronTask["OrdersCashPayments"] = "OrdersCashPayments";
    CronTask["OrdersCustomerFeedbackRequests"] = "OrdersCustomerFeedbackRequests";
    CronTask["OrdersCustomersReminders"] = "OrdersCustomersReminders";
    CronTask["OrdersDriverReminders"] = "OrdersDriverReminders";
    CronTask["PreparePayouts"] = "PreparePayouts";
    CronTask["ProcessRealizedOrders"] = "ProcessRealizedOrders";
    CronTask["ProcessExistingVehicleInsurances"] = "ProcessExistingVehicleInsurances";
    CronTask["ProcessVehicleInsurance"] = "ProcessVehicleInsurance";
    CronTask["RecalculateActivityForDrivers"] = "RecalculateActivityForDrivers";
    CronTask["RecalculateDriversCancellationRateDaily"] = "RecalculateDriversCancellationRateDaily";
    CronTask["RecalculateDriverScoreDaily"] = "RecalculateDriverScoreDaily";
    CronTask["ReferralRefereeEmail"] = "ReferralRefereeEmail";
    CronTask["RemoveOldNotifications"] = "RemoveOldNotifications";
    CronTask["RequestCustomerSupportActionOnFeedbacks"] = "RequestCustomerSupportActionOnFeedbacks";
    CronTask["SchedulePendingTasks"] = "SchedulePendingTasks";
    CronTask["SendAbandonedCartEmails"] = "SendAbandonedCartEmails";
    CronTask["SendAirportTransferEmails"] = "SendAirportTransferEmails";
    CronTask["SendComboExpiresSoonNotifications"] = "SendComboExpiresSoonNotifications";
    CronTask["SendFailedPreauthorizedPaymentEmail"] = "SendFailedPreauthorizedPaymentEmail";
    CronTask["SendFirstRideEmailToRMs"] = "SendFirstRideEmailToRMs";
    CronTask["SendFirstRideFeedbackEmails"] = "SendFirstRideFeedbackEmails";
    CronTask["SendHigherVehicleCategoryUpgradeEmails"] = "SendHigherVehicleCategoryUpgradeEmails";
    CronTask["SendMissingAddressesEmails"] = "SendMissingAddressesEmails";
    CronTask["SendOrderTrackingReminderPushNotification"] = "SendOrderTrackingReminderPushNotification";
    CronTask["SendReservedOrderReminderEmails"] = "SendReservedOrderReminderEmails";
    CronTask["SendReturnTripEmails"] = "SendReturnTripEmails";
    CronTask["SendTravelAgentFeedbackRequests"] = "SendTravelAgentFeedbackRequests";
    CronTask["SendTripChangedEmails"] = "SendTripChangedEmails";
    CronTask["SendTripTrackingPushNotification"] = "SendTripTrackingPushNotification";
    CronTask["SetTripTrackingIssue"] = "SetTripTrackingIssue";
    CronTask["SendFirstTripTrackingReminder"] = "SendFirstTripTrackingReminder";
    CronTask["SendSecondTripTrackingReminder"] = "SendSecondTripTrackingReminder";
    CronTask["SendThirdTripTrackingReminder"] = "SendThirdTripTrackingReminder";
    CronTask["SendUntrackedTripSlackAlert"] = "SendUntrackedTripSlackAlert";
    CronTask["SyncFreshTripPriceToLegacy"] = "SyncFreshTripPriceToLegacy";
    CronTask["SyncMangopayEvents"] = "SyncMangopayEvents";
    CronTask["SyncUpcomingFreshTripAssignationToLegacy"] = "SyncUpcomingFreshTripAssignationToLegacy";
    CronTask["TARegistration"] = "TARegistration";
    CronTask["UpcomingCashBookingWithNotApprovedPickUp"] = "UpcomingCashBookingWithNotApprovedPickUp";
    CronTask["UpcomingTripWithNotAssignedDriver"] = "UpcomingTripWithNotAssignedDriver";
    CronTask["UpdateComboSnapshots"] = "UpdateComboSnapshots";
    CronTask["UpdateCreditLinePeriods"] = "UpdateCreditLinePeriods";
    CronTask["UpdateCurrencyRates"] = "UpdateCurrencyRates";
    CronTask["UpdateLandmassDriversCount"] = "UpdateLandmassDriversCount";
    CronTask["UpdateMangopayWalletStates"] = "UpdateMangopayWalletStates";
    CronTask["UpdateOrderAffiliateConversionStatus"] = "UpdateOrderAffiliateConversionStatus";
    CronTask["UpdateTravelAgentRealizedOrders"] = "UpdateTravelAgentRealizedOrders";
    CronTask["UploadGoogleTTDFeed"] = "UploadGoogleTTDFeed";
    CronTask["SendVehicleInsuranceExpirationReminders"] = "SendVehicleInsuranceExpirationReminders";
})(CronTask || (exports.CronTask = CronTask = {}));
//# sourceMappingURL=CronTask.js.map